module.exports = __webpack_public_path__ + "img/argenta.a90a17b7.svg";